import { render, staticRenderFns } from "./FlowItem.vue?vue&type=template&id=2a60928c&scoped=true&"
import script from "./FlowItem.vue?vue&type=script&lang=js&"
export * from "./FlowItem.vue?vue&type=script&lang=js&"
import style0 from "./FlowItem.vue?vue&type=style&index=0&id=2a60928c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60928c",
  null
  
)

export default component.exports